(function () {
  "use strict";

  angular.module("app").controller("MapController", MapController);

  MapController.$inject = [
    "LocalizadorService",
    "$http",
    "$timeout",
    "$log",
    "$document",
    "$sce",
    "$scope",
    "uiGmapGoogleMapApi",
  ];

  function MapController(
    LocalizadorService,
    $http,
    $timeout,
    $log,
    $document,
    $sce,
    $scope,
    GoogleMapApi
  ) {
    var vm = this;
    vm.loading = true;
    // vm.icon = "/img/i_marker.png";
    //vm.iconiai = "/imgn/i_markeriai.jpg";
    //vm.cluster = "/img/i_cluster.png";
    vm.clusterred = "/img/i_cluster-red.svg";
    vm.clusterblue = "/img/i_cluster-blue.svg";
    vm.pais = "";
    vm.esiai = "todos";
    vm.zip = "";
    vm.provincia = "";
    vm.countrycode = "es";
    vm.selectedCentroId = null;
    vm.centros = [];
    vm.markers = [];
    vm.localizado = false;
    vm.mapa = false;
    vm.contadorVisibles = 0;

    vm.mapEvents = {
      bounds_changed: function (map) {
        return GoogleMapApi.then(
          (function (_this) {
            return function (maps) {
              var bounds = new google.maps.LatLngBounds();
              vm.contadorVisibles = 0;
              for (var cont = 0; cont < vm.centros.length; cont++) {
                vm.centros[cont].visible = false;
                var latlong = new google.maps.LatLng(
                  Number(vm.centros[cont].latitud_coordenadas),
                  Number(vm.centros[cont].longitud_coordenadas)
                );
                if (map.getBounds().contains(latlong)) {
                  vm.centros[cont].visible = true;
                  vm.contadorVisibles++;
                }
              }
            };
          })(this)
        );
      },
    };

    var istouch = "ontouchstart" in document.documentElement;
    vm.map = {
      center: { latitude: "40.4637", longitude: "-3.7492" },
      zoom: 5,
      clusterOptions: {
        minimumClusterSize: 2,
        zoomOnClick: true,
        styles: [
          {
            url: vm.clusterblue, // icono azul para clusters pequeños
            width: 32,
            height: 32,
            textColor: "white",
            textSize: 13,
          },
          {
            url: vm.clusterred, // icono rojo para clusters grandes
            width: 48,
            height: 48,
            textColor: "white",
            textSize: 14,
          },
        ],
        averageCenter: true,
        clusterClass: "cluster-icon",
      },
      options: {
        streetViewControl: false,
        mapTypeControl: false,
        gestureHandling: istouch ? "cooperative" : "greedy",
      },
      markers: [],
      window: {
        marker: {},
        show: true,
        closeClick: function () {
          this.show = false;
        },
        model: {
          centro: {
            id: 0,
            address: "test",
          },
        },
        options: {},
      },
    };

    (vm.markers = []), (vm.coords = {});
    vm.radio = 10000;

    vm.centros = [];
    vm.bnds = "";

    vm.address = "";

    vm.getLatitudeLongitude = function (callback) {
      return GoogleMapApi.then(
        (function (_this) {
          return function (maps) {
            var address = vm.address || vm.country;
            var geocoder = new google.maps.Geocoder();

            if (geocoder) {
              geocoder.geocode(
                {
                  address: address,
                  componentRestrictions: { country: vm.countrycode },
                },
                function (results, status) {
                  if (status == google.maps.GeocoderStatus.OK) {
                    callback(results[0]);
                  }
                }
              );
            }
          };
        })(this)
      );
    };

    vm.goScroll = function (centro) {
      $(".scroll").animate(
        {
          scrollTop:
            $(".scroll").scrollTop() +
            $(".store_" + centro.id).position().top -
            40,
        },
        800
      );
    };

    vm.markersEvents = {
	click: function (gMarker, eventName, model) {

        if (model.centro != "") {
          LocalizadorService.getActivo(model.centro.referencia_catastral).then(
              function (activo) {

              var activoSingle = activo.activo;

              var precio = activoSingle.precio;

              if (activo.grupo_activos == null || activo.grupo_activos == false) {
                var infoContent =
                  `
                    <div class="info-content">
                        <a href="activo/` +
                  activoSingle.id +
                  `" class="mb-2 d-block text-xl">` +
                  activoSingle.calle +
                  `</a>
                        <p class="border-bottom pb-2 text-lg">` +
                  activoSingle.municipio.nombre +
                  `</p>
                        <p>Uso principal: ` +
                  activoSingle.uso.nombre +
                  `</p>
                        <p>` +
                  activoSingle.tipo_de_activo.nombre +
                  `</p>
                        <p>` +
                  activoSingle.metros_cuadrados +
                  `m2</p>
                        <p class="text-lg"><strong>Precio: ` +
                  precio +
                  `</p></strong>
                    </div>
                `;
              } else {
                var infoContent =
                  '<div class="info-content"> <h5> Grupo Activos </h5>';
                for (var i = 0; i < activo.grupo_activos.length; i++) {
                  infoContent +=
                    `
                    
                        
                        <a href="activo/` +
                    activo.grupo_activos[i].id +
                    `" class="mb-2 d-block text-xl">` +
                    activo.grupo_activos[i].calle +
                    `</a>
                        <p class="border-bottom pb-2 text-lg">` +
                    activo.grupo_activos[i].municipio.nombre +
                    `</p>
                        <p>Uso principal: ` +
                    activo.grupo_activos[i].uso.nombre +
                    `</p>
                        <p>` +
                    activo.grupo_activos[i].tipo_de_activo.nombre +
                    `</p>
                        <p>` +
                    activo.grupo_activos[i].metros_cuadrados +
                    `m2</p>
                        <p class="text-lg"><strong>Precio: ` +
                    activo.grupo_activos[i].precio +
                    `</p></strong>
                    
                `;
                }
                infoContent += "</div>";
              }

              var infoWindow = new google.maps.InfoWindow({
                content: infoContent,
              });
              infoWindow.open(gMarker.map, gMarker);

              $timeout(function () {
                vm.map.window.model = model;
                vm.map.window.show = true;

                // vm.goScroll(model.centro);
              });
            }
          );
        }
      },
    };

  
    vm.windowParams = {
      test: function () {},
      window: vm.map.window,
    };

    vm.getCenterCentros = function (init) {
	if (vm.centros.length === 0)
	{

	    vm.loading = false;
	    return;

	}
      var centros = vm.centros;

      var bounds = new google.maps.LatLngBounds();
      for (var cont = 0; cont < centros.length; cont++) {
        centros[cont].marker = true;

        var myLatLng = new google.maps.LatLng(
          Number(centros[cont].latitud_coordenadas),
          Number(centros[cont].longitud_coordenadas)
        );

        centros[cont].contador = cont + 1;
        var ret = {
          latitude: Number(centros[cont].latitud_coordenadas),
          longitude: Number(centros[cont].longitud_coordenadas),
          title: "m" + cont,
          centro: centros[cont],
          icon: vm.icon,
          id: cont + 1,
        };
        vm.markers.push(ret);
        bounds.extend(myLatLng);
      }

      $timeout(function () {
        vm.loading = false;
      }, 3000);
    };

    $scope.$on("getActivos", function (e, reset) {
      if (vm.mapa) vm.setMarkersDireccion();
    });

    vm.cargarMapa = function () {
      vm.mapa = true;
      vm.setMarkersDireccion();

      $timeout(function () {
        jQuery(".transparent-layer").width(jQuery(".c-mapa_map").width());
        jQuery(".transparent-layer").height(jQuery(".c-mapa_map").height());
      }, 50);
    };

    vm.setMarkersDireccion = function (callback) {
      vm.loading = true;
      LocalizadorService.getTiendas(
        $scope.$parent.ac,
        $scope.$parent.ac.startDate,
        $scope.$parent.ac.endDate
      ).then(function (data) {
        vm.markers = [];

        if (data.centros.length > 0) {
          vm.centros = data.centros;

          vm.getCenterCentros(true);
        }else{
	    vm.loading = false;
	}

        if (typeof callback != "undefined") {
          callback();
        }
      });
    };
  }
})();
